import { createFileRoute } from '@tanstack/react-router'
import { ProfileFormPage } from '~/features/people/ProfileFormPage'

export const Route = createFileRoute('/profil/$token')({
  component: function Profile() {
    return <ProfileFormPage token={Route.useParams().token} />
  },
})
